import axios from "axios";
import { Message } from "element-ui";
// import { getToken, removeToken } from '@/utils/auth'
import config from "@/static/config";
import LoadingService from "./loading"; // 假设你的loading服务文件叫loading.js
// import client from "./modules/client";
import router from "@/router";
import * as Paho from "paho-mqtt";
import CryptoJS from "crypto-js";
import store from "@/store";
import vm from "../main";
import { handleUrlLink } from "@/utils/handleWebSocket";
// 重连配置
const RETRY_CONFIG = {
  MAX_RETRIES: 3, // 最大重试次数
  RETRY_DELAY: 1000, // 重试延迟(ms)
  RETRY_CODES: [408, 500, 502, 503, 504], // 需要重试的状态码
  RETRY_NETWORK_ERRORS: ["ECONNABORTED", "ETIMEDOUT", "NETWORK_ERROR"], // 需要重试的网络错误
  RETRY_METHODS: ["get"], // 需要重试的请求方法, "post", "put", "delete"
  WHITE_LIST: ["/login", "/logout"], // 不重试的白名单接口
};
let errtt = 0;

// create an axios instance
const service = axios.create({
  baseURL: config.baseUrl, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
});
let mqttReady = false; // 连接成功 = true，断开 = false
let preUrl = config.baseUrl;
let params = {};
let params_data = {};
// 创建一个计数器来跟踪进行中的请求数量
let activeRequests = 0;
let tokenAbnormal = false;
let userAbnormal = false;
let instanceId = "post-cn-fsw4bzjg904"; //实例 ID，购买后从控制台获取
let host = "post-cn-fsw4bzjg904.mqtt.aliyuncs.com"; // 设置当前用户的接入点域名，接入点获取方法请参考接入准备章节文档，先在控制台创建实例
let port = 443; //WebSocket 协议服务端口，如果是走 HTTPS，设置443端口
let topic = undefined; //需要操作的 Topic,第一级父级 topic 需要在控制台申请
let useTLS = true; //是否走加密 HTTPS，如果走 HTTPS，设置为 true
//账号 accesskey，从账号系统控制台获取
//阿里云账号AccessKey拥有所有API的访问权限，建议您使用RAM用户进行API访问或日常运维。
//强烈建议不要把AccessKey ID和AccessKey Secret保存到工程代码里，否则可能导致AccessKey泄露，威胁您账号下所有资源的安全。
//可以把AccessKey ID和AccessKey Secret保存在环境变量。运行本代码示例之前，请先配置环境变量MQTT_AK_ENV和MQTT_SK_ENV
//例如：export MQTT_AK_ENV=access_key_id
//     export MQTT_SK_ENV=access_key_secret
//需要将access_key_id替换为已准备好的AccessKey ID，access_key_secret替换为AccessKey Secret
let accessKey = "LTAI5t8bh3zVex7G6SZKhGAL";
//账号的的 SecretKey，在阿里云控制台查看
let secretKey = "IWVdZPDFkszG0JsLauoa0YkLF9cstk";
let cleansession = true;
let groupId = undefined; //MQTT GroupID,创建实例后从 MQTT 控制台创建
let clientId = undefined; //GroupId@@@DeviceId，由控制台创建的 Group ID 和自己指定的 Device ID 组合构成
let mqtt = undefined;
let reconnectTimeout = 8000;
let username =
  "Signature|" + "LTAI5t8bh3zVex7G6SZKhGAL" + "|" + "post-cn-fsw4bzjg904"; //username和 Password 签名模式下的设置方法，参考文档 https://help.aliyun.com/document_detail/48271.html?spm=a2c4g.11186623.6.553.217831c3BSFry7
let password = undefined;
let env = "";
let message = "";
if (config.baseUrl.indexOf("sinpm") != -1) {
  topic = "user_event";
  groupId = "GID_USER";
  env = "prd";
} else if (config.baseUrl.indexOf("meiliq") != -1) {
  topic = "pre_user_event";
  groupId = "GID_PRE_USER";
  env = "pre";
} else {
  topic = "dev_user_event";
  groupId = "GID_DEV_USER";
  env = "dev";
}
let urlLink = "";
clientId = groupId + "@@@123456";
password = CryptoJS.HmacSHA1(clientId, secretKey).toString(CryptoJS.enc.Base64);
let isMQTTInitialized = false;
// 新增一个标志变量，记录是否正在尝试重连
let isReconnecting = false;

function MQTTconnect() {
  console.log("222222222222");
  console.log(store.getters);
  clientId =
    groupId +
    "@@@" +
    "admin_" +
    store.getters.trunkId +
    "_" +
    store.getters.account;
  password = CryptoJS.HmacSHA1(clientId, secretKey).toString(
    CryptoJS.enc.Base64
  );
  if (mqtt && mqtt.isConnected()) {
    console.log("MQTT已经连接，无需重复连接");
    return;
  }
  if (isReconnecting) return;
  if (mqtt && mqtt.isConnected()) return;

  isReconnecting = true;
  mqttReady = false;
  try {
    mqtt = new Paho.Client(host, port, clientId);
    console.log("链接的ClientId" + clientId);
    var options = {
      timeout: 10,
      onSuccess: () => {
        onConnect();

        // ========== 绝杀：浏览器后台也强制保持连接 ==========
        setInterval(() => {
          if (mqtt && mqtt.isConnected()) {
            mqtt.send("ping", "keepalive", 0, false); // 极小空消息，防断开
          }
        }, 25000);
      },
      mqttVersion: 4,
      cleanSession: cleansession,
      keepAliveInterval: 30, // 必须 30
      onFailure: function (message) {
        console.log("MQTT连接失败", message);
        isReconnecting = false;
        if (isMQTTInitialized) {
          setTimeout(MQTTconnect, reconnectTimeout);
        }
      },
    };

    mqtt.onConnectionLost = (err) => {
      console.log("连接断开:", err);
      mqttReady = false;
      isReconnecting = false;
      setTimeout(MQTTconnect, 1000); // 重连更快
    };

    mqtt.onMessageArrived = (message) => {
      console.log("收到消息:", message.payloadString);
    };

    if (username != null) {
      options.userName = username;
      options.password = password;
      options.useSSL = useTLS;
    }

    mqtt.connect(options);
  } catch (error) {
    console.error("MQTT连接异常:", error);
    isReconnecting = false;
  }
}
function onConnect() {
  console.log("MQTT连接成功");
  mqttReady = true; // ✅
  isReconnecting = false;
  isMQTTInitialized = true;
  // 只保留订阅主题，移除消息发送逻辑
  mqtt.subscribe(topic, { qos: 0 });
  console.log("MQTT连接成功并已订阅主题");
}
function onMessageArrived(message) {
  var topic = message.destinationName;
  var payload = message.payloadString;
  console.log("recv msg : " + topic + "   " + payload);
}

function onConnectionLost() {
  console.log("MQTT连接已断开");
  isReconnecting = false;

  // 只有在初始化后才尝试重连
  if (isMQTTInitialized) {
    setTimeout(MQTTconnect, reconnectTimeout);
  }
}

function _sendMessage(apiUrl, jsonStr, url) {
  try {
    // 创建并发送JSON消息
    const jsonPayload = JSON.stringify({
      appName: "改版后的总后台系统",
      operType: "",
      orignalData: "",
      currentData: "",
      changeData: "",
      api: apiUrl,
      apiParam: url,
      apidata: jsonStr.msg,
      remark: "",
      env: env,
      time: new Date().toLocaleString("zh-CN"),
      accountName: store.getters.account,
      accountId: store.getters.userId,
    });

    let message = new Paho.Message(jsonPayload);
    message.destinationName = topic + "/p2p/" + clientId;

    mqtt.send(message);
    console.log("MQTT消息发送成功:", message.destinationName);
    console.log("MQTT消息发送成功:", message);
  } catch (error) {
    console.error("MQTT消息发送失败:", error);
  }
}

function sendMQTTMessage(apiUrl, jsonStr, url) {
  // 检查连接状态
  if (!mqtt || !mqtt.isConnected()) {
    console.log("MQTT未连接，尝试重连...");
    MQTTconnect();
    // 重连后延迟发送消息
    setTimeout(() => {
      _sendMessage(apiUrl, jsonStr, url);
    }, 2000);
    return;
  }

  // 直接发送消息
  _sendMessage(apiUrl, jsonStr, url);
}

const retryInterceptor = async (error) => {
  const config = error.config;

  // 检查是否应该重试
  const shouldRetry =
    config.__retryCount < RETRY_CONFIG.MAX_RETRIES &&
    RETRY_CONFIG.RETRY_METHODS.includes(config.method?.toLowerCase() || "") &&
    // 网络错误
    (!error.response ||
      // 特定状态码
      RETRY_CONFIG.RETRY_CODES.includes(error.response?.status) ||
      // 特定网络错误码
      RETRY_CONFIG.RETRY_NETWORK_ERRORS.includes(error.code)) &&
    // 非白名单接口
    !RETRY_CONFIG.WHITE_LIST.some((url) => config.url.includes(url));

  if (shouldRetry) {
    config.__retryCount = (config.__retryCount || 0) + 1;

    // 计算重试延迟（指数退避算法）
    const delay =
      RETRY_CONFIG.RETRY_DELAY * Math.pow(2, config.__retryCount - 1);

    console.log(
      `请求 ${config.url} 失败，第 ${config.__retryCount}/${RETRY_CONFIG.MAX_RETRIES} 次重试，延迟 ${delay}ms`
    );

    // 创建新的Promise来处理重试
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(service(config));
      }, delay);
    });
  }
  if (config.__retryCount === 3 && errtt == 0) {
    errtt = 1;
    console.log("超过最大请求次数" + urlLink);
    sendMQTTMessage(
      urlLink,
      { msg: "服务器未响应" },
      { postdata: params_data, getdata: params }
    );
    Message({
      message: "服务器未响应",
      type: "error",
      duration: 5 * 1000,
    });
  }

  console.log(
    `请求 ${config.url} 失败，已达到最大重试次数 ${RETRY_CONFIG.MAX_RETRIES} 次，不再重试`
  );
  return Promise.reject(error);
};
const createRetryInterceptor = (config) => {
  // 只在第一次请求时初始化重试计数
  if (config.__retryCount === undefined) {
    config.__retryCount = 0;
    errtt = 0;
  }
  return config;
};
// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    // if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config = createRetryInterceptor(config);
    config.headers["TERMINAL_TYPE"] = "5";
    config.headers["SYSTEM_TYPE"] = "1";
    config.headers["LOGIN_TYPE"] = store.getters.loginType;
    if (store.getters.token) {
      config.headers["Authorization"] = `Bearer ${store.getters.token}`;
    }
    params_data = config.data;
    params = config.params;
    console.log("接口名字");
    console.log(config);
    console.log(params);
    if (config.url.indexOf("https:") != -1) {
      urlLink = config.url;
    } else {
      // 规范化拼接：baseURL 尾斜杠与相对路径头斜杠只保留一个，
      // 否则本地(/manager) + 相对路径(customer/delete) 会拼成 /managercustomer/delete，
      // 导致响应拦截器里 urlLink.indexOf("/customer/delete") 判不中
      urlLink =
        preUrl.replace(/\/+$/, "") + "/" + config.url.replace(/^\/+/, "");
    }
    const whiteList = [
      "/role/model/cate",
      "/dict/class/save",
      "/property/mapping/save",
      "/process/save",
      "/process/item/save",
      "/notify/model",
      "/wechat/config/update",
      "/wechat/config/add",
      "/department/update",
      "/department/add",
      "/role/add",
      "/role/update",
      "/employee/update",
      "/employee/add",
      "/category/update",
      "/category/add",
      "/device/upgrade/add",
      "/device/upgrade/update",
      "property/save",
      "/device/class/update",
      "/device/class/add",
      "/device/update",
      "/device/add",
      "/device/command/update",
      "/device/command/add",
      "/device/model/add",
      "/device/model/update",
      "/menu/update",
      "/menu/add",
      "/button/update",
      "/button/add",
      "/market/application/add",
      "/market/application/update",
      "/customer/update",
      "/customer/add",
      "/conf",
      "/customer/user/init",
      "/device/add",
      "/device/use/log/search",
      "/device/delete",
      "/device/execute",
    ]; // no redirect whitelist
    console.log("接口名----" + config.url);
    console.log(whiteList.indexOf(config.url) !== -1);
    console.log();
    //console.log("whiteList.indexOf(config.url) !== -1"+(whiteList.indexOf(config.url) !== -1))
    // 每次请求时增加计数器
    activeRequests++;

    if (
      ((config.url.indexOf("https") != -1 &&
        whiteList.indexOf(config.url.split("com")[1]) !== -1) ||
        whiteList.indexOf(config.url) !== -1) &&
      activeRequests === 1 &&
      !LoadingService.loadingInstance
    ) {
      console.log("进入");
      LoadingService.show(); // 显示loadingd
    } else if (
      config.url.indexOf("/device/use/log/search") != -1 &&
      !LoadingService.loadingInstance
    ) {
      console.log("进入" + config.url);
      LoadingService.show(); // 显示loadingd
    }

    return config;
  },
  (error) => {
    // 请求出错时减少计数器
    activeRequests--;
    if (activeRequests === 0) {
      LoadingService.hide(); // 隐藏loading
    }
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

async function handleSync() {
  const returnParams = await handleUrlLink(urlLink, params, params_data);
  if (returnParams) {
    sendCommonMQTTMessage(urlLink, returnParams, {
      postdata: params_data,
      getdata: params,
    });
  }
}
function parseQueryString(queryString) {
  const urlParams = new URLSearchParams(queryString);
  const params = {};
  for (let param of urlParams.entries()) {
    params[param[0]] = param[1];
  }
  return params;
}
function sendCommonMQTTMessage(apiUrl, jsonStr, params, type, pass) {
  // 检查连接状态
  if (!mqtt || !mqtt.isConnected()) {
    console.log("MQTT未连接，尝试重连...");
    MQTTconnect();
    // 重连后延迟发送消息
    setTimeout(() => {
      _sendMessage1(apiUrl, jsonStr, params, type, pass);
    }, 2000);
    return;
  }

  // 直接发送消息
  _sendMessage1(apiUrl, jsonStr, params, type, pass);
}
function _sendMessage1(apiUrl, jsonStr, params, type, pass) {
  try {
    console.log("_sendMessage1参数");
    console.log(apiUrl);
    console.log(jsonStr);
    console.log(params);
    jsonStr.api = apiUrl;
    jsonStr.env = env;
    type = jsonStr.type;
    jsonStr.regionAgentName = store.getters.companyName;
    jsonStr.accountId = store.getters.userId;
    jsonStr.accountName = store.getters.account;
    jsonStr.regionAgentId = store.getters.trunkId;
    if (jsonStr.password && jsonStr.password == "password") {
      if (params.postdata) {
        jsonStr.currentData = params.postdata;
      } else if (params.getdata) {
        jsonStr.currentData = params.getdata;
      } else {
        // 示例用法
        const queryString = "?" + apiUrl.split("?")[1];
        const maomaoObj = parseQueryString(queryString);
        jsonStr.currentData = maomaoObj;
      }

      jsonStr.orignalData = "";
      jsonStr.changeData = "";
      jsonStr.apiParam = "";
    } else {
      if (jsonStr.password && jsonStr.password == "updatePhone") {
        const parf = JSON.parse(localStorage.getItem("updatePhone"));
        jsonStr.orignalData = parf;
        if (params.postdata) {
          jsonStr.currentData = params.postdata;
          jsonStr.currentData.editObj = undefined;
        } else if (params.getdata) {
          jsonStr.currentData = params.getdata;
          jsonStr.currentData.editObj = undefined;
        } else {
          // 示例用法
          const queryString = "?" + apiUrl.split("?")[1];
          const maomaoObj = parseQueryString(queryString);
          jsonStr.currentData = maomaoObj;
          jsonStr.currentData.editObj = undefined;
        }
        jsonStr.changeData = "";
      } else {
        if (type === 1 || type === 4) {
          //新增

          if (params.postdata) {
            jsonStr.currentData = params.postdata;
          } else if (params.getdata) {
            jsonStr.currentData = params.getdata;
          } else {
            // 示例用法
            const queryString = "?" + apiUrl.split("?")[1];
            const maomaoObj = parseQueryString(queryString);
            jsonStr.currentData = maomaoObj;
          }

          jsonStr.orignalData = "";
          jsonStr.changeData = "";
        } else if (type === 2) {
          console.log("编辑");
          console.log(params);
          if (params.postdata) {
            jsonStr.orignalData = params.postdata.editObj;
            jsonStr.currentData = params.postdata;
            jsonStr.currentData.editObj = undefined;
          } else if (params.getdata) {
            jsonStr.orignalData = params.getdata.editObj;
            jsonStr.currentData = params.getdata;
            jsonStr.currentData.editObj = undefined;
          } else {
            const queryString = "?" + apiUrl.split("?")[1];
            const maomaoObj = parseQueryString(queryString);
            jsonStr.apiParam = maomaoObj;
          }
          jsonStr.changeData = "";
        } else if (type === 3) {
          console.log("删除");
          console.log(apiUrl);
          console.log(params);
          jsonStr.currentData = "";
          jsonStr.orignalData = "";
          jsonStr.changeData = "";
          if (params.getdata) {
            jsonStr.apiParam = params.getdata;
          } else if (params.postdata) {
            jsonStr.apiParam = params.postdata;
          } else {
            const queryString = "?" + apiUrl.split("?")[1];
            const maomaoObj = parseQueryString(queryString);
            jsonStr.apiParam = maomaoObj;
          }
        }
      }
    }
    if (
      apiUrl.indexOf("device/update") != -1 ||
      apiUrl.indexOf("/device/delete") != -1 ||
      apiUrl.indexOf("/device/execute") != -1
    ) {
      jsonStr.operateTrackType = 1;
    }
    console.log("传给webS");
    console.log(jsonStr);

    // 创建并发送JSON消息
    const jsonPayload = JSON.stringify(jsonStr);
    console.log("MQTT:", topic + "/p2p/" + clientId);
    let message = new Paho.Message(jsonPayload);
    message.destinationName = topic + "/p2p/" + clientId;
    mqtt.send(message);

    console.log("MQTT消息发送成功:", message.destinationName);
  } catch (error) {
    console.error("MQTT消息发送失败:", error);
  }
}
async function waitForMqttReadyAndSync() {
  // 最多等待 10 秒，防止死等
  const maxWaitTime = 10000;
  const startTime = Date.now();

  while (true) {
    // 超时退出
    if (Date.now() - startTime > maxWaitTime) {
      console.error("MQTT 连接超时，取消同步");
      return;
    }

    // 已就绪 → 执行同步
    if (mqttReady && mqtt && mqtt.isConnected()) {
      console.log("✅ MQTT 已连接，开始执行 handleSync");
      try {
        await handleSync();
      } catch (err) {
        console.error("handleSync 执行失败：", err);
      }
      return;
    }

    // 未连接 → 尝试连接
    if (!mqtt || !mqtt.isConnected()) {
      console.log("MQTT 未连接，尝试连接...");
      MQTTconnect();
    }

    // 每隔 300ms 检查一次
    await new Promise((resolve) => setTimeout(resolve, 300));
  }
}
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */

  // 401 或 4000 ~ 4999 跳登录

  async (response) => {
    activeRequests--;
    if (activeRequests === 0) {
      LoadingService.hide(); // 隐藏loading
    }
    if (response.status === 200) {
      const { code, data, msg } = response.data;
      console.log("接3333333333333333口名字code" + code);
      console.log(data);
      switch (code) {
        case "0":
          try {
            if (store.getters.userId) {
              waitForMqttReadyAndSync();
            }
          } catch (e) {
            console.log("aaaaaaaaaaaaaaa");
            console.log(e);
          }
          tokenAbnormal = false;

          if (
            data &&
            (urlLink.indexOf("/customer/delete") != -1 ||
              urlLink.indexOf("/dept/delete") != -1)
          ) {
            return Promise.resolve(response.data);
          } else if (data && urlLink.indexOf("/customer/delete") == -1) {
            return Promise.resolve(data);
          } else if (!data && urlLink.indexOf("/device/upgrade/delete") != -1) {
            console.log("接3333333333333333口名字");
            console.log(response);
            return Promise.resolve(response);
          } else {
            return Promise.reject(data);
          }

          break;
        case "49999":
          return Promise.resolve(response);
          break;
        case "401":
          if (!tokenAbnormal) {
            tokenAbnormal = true;
            // 弹出框
            // 设置定时器，确保下次异常时弹出框正常弹出
            // console.log(response)
            if (response.config.url.includes("/logout")) {
              return;
            }
            Message({
              message: msg || "Error",
              type: "error",
              duration: 2 * 1000,
            });
            setTimeout(() => {
              tokenAbnormal = false;

              store.dispatch("user/logout", vm);
              // removeToken()
            }, 2000);
          }

          break;
        case "403":
          Message({
            message: "无权限访问",
            type: "error",
            duration: 2 * 1000,
          });
          break;
        case "4991":
          if (!tokenAbnormal) {
            tokenAbnormal = true;
            // 弹出框
            // 设置定时器，确保下次异常时弹出框正常弹出
            Message({
              message: msg || "Error",
              type: "error",
              duration: 2 * 1000,
            });
            setTimeout(() => {
              tokenAbnormal = false;

              store.dispatch("user/logout", vm);
              // removeToken()
            }, 2000);
          }

          break;
        case "4999":
          if (!userAbnormal) {
            userAbnormal = true;
            // 弹出框
            // 设置定时器，确保下次异常时弹出框正常弹出
            if (response.config.url.includes("/login")) {
              userAbnormal = false;
              Message({
                message: msg || "Error",
                type: "error",
                duration: 2 * 1000,
              });
              return Promise.reject(response);
            }
            Message({
              message: msg || "Error",
              type: "error",
              duration: 2 * 1000,
            });
            setTimeout(() => {
              userAbnormal = false;

              store.dispatch("user/logout", vm);
            }, 2000);
          }

          break;
        default:
          if (msg.length > 100) {
            Message({
              message: "系统错误，请联系管理员！",
              type: "error",
              duration: 2 * 1000,
            });
          } else {
            Message({
              message: msg || "Error",
              type: "error",
              duration: 2 * 1000,
            });
          }

          return Promise.reject(response);
      }
    }
  },
  async (error) => {
    // 响应出错时减少计数器
    activeRequests--;
    if (activeRequests === 0) {
      setTimeout(() => {
        LoadingService.hide(); // 隐藏loading
      }, 2000);
    }
    // TODO: 超时暂未处理
    console.log("接口连接失败", error.response);
    const err = error.response;
    if (err && err.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
          break;
        case 403:
          console.log("403");
          Message({
            message: "暂无权限访问",
            type: "error",
            duration: 5 * 1000,
          });
          break;

        // 404请求不存在
        case 404:
          // router.push('/404')
          Message({
            message: "请求地址不存在",
            type: "error",
            duration: 5 * 1000,
          });
          break;
        // 500服务端错误
        case 500:
          console.log("500");
          break;
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.message,
            type: "error",
            duration: 5 * 1000,
          });
      }
      return Promise.reject(error.response);
    }

    // 调用重试拦截器
    const retryResult = await retryInterceptor(error);
    if (retryResult !== error) {
      // 如果重试成功，返回重试结果
      return retryResult;
    }

    return Promise.reject(error.response);
  }
);

export default service;
